import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import aboutImg from '../assets/about-building.jpg';

export const AboutSection: React.FC = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  const isInView = useInView(containerRef, { once: true, margin: "-100px" });

  return (
    <section id="about" ref={containerRef} className="py-24 bg-white overflow-hidden">
      <div className="container mx-auto px-6">
        <div className="flex flex-col lg:flex-row items-center gap-16">
          {/* Image Side */}
          <motion.div 
            className="w-full lg:w-1/2 relative"
            initial={{ opacity: 0, x: -50 }}
            animate={isInView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.8 }}
          >
            <div className="relative z-10 rounded-sm overflow-hidden shadow-2xl">
              <img 
                src={aboutImg} 
                alt="Modern Corporate Architecture" 
                className="w-full h-auto object-cover"
              />
            </div>
            {/* Decorative elements */}
            <div className="absolute -bottom-6 -right-6 w-2/3 h-2/3 border-4 border-amber-500/20 z-0" />
            <div className="absolute -top-6 -left-6 w-1/3 h-1/3 bg-zinc-100 z-0" />
          </motion.div>

          {/* Content Side */}
          <motion.div 
            className="w-full lg:w-1/2 space-y-8"
            initial={{ opacity: 0, x: 50 }}
            animate={isInView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            <div>
              <h4 className="text-amber-500 font-bold uppercase tracking-widest text-sm mb-2">About UGW Global</h4>
              <h2 className="text-3xl md:text-4xl font-bold text-zinc-900 leading-tight">
                Bridging Strategic Advisory, Capital Markets & Technical Expertise
              </h2>
            </div>

            <div className="space-y-6 text-zinc-600 leading-relaxed">
              <p>
                At UGW GLOBAL, we operate at the intersection of strategic advisory, capital markets, and technical expertise. We deliver comprehensive brokerage and consultancy services across the natural resources, commodities, hospitality, and real estate sectors.
              </p>
              <p>
                We support clients throughout the entire lifecycle of a product or an asset—from supply/demand satisfaction, acquisition, and structuring facilitation to supply chain, operational optimization, and risk management—ensuring every project achieves its full commercial and technical value.
              </p>
              <p>
                Our approach is built on a global mindset and a disciplined, solutions-driven methodology. With direct access to institutional stakeholders, industry professionals, high-level operators, and commodity producers worldwide, we provide insights and actionable guidance that align with each client’s strategic objectives.
              </p>
            </div>

            <div className="pt-4">
              <div className="grid grid-cols-2 gap-8">
                <div>
                  <div className="text-4xl font-bold text-zinc-900 mb-1">Global</div>
                  <div className="text-sm text-zinc-500 uppercase tracking-wider">Network Reach</div>
                </div>
                <div>
                  <div className="text-4xl font-bold text-zinc-900 mb-1">End-to-End</div>
                  <div className="text-sm text-zinc-500 uppercase tracking-wider">Turnkey Solutions</div>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};